class FilterOrderer {
  constructor() {
    // Filters order defined as global variables
    this.accessoriesOrder = Antonioli.filters.accessories_filter_order;
    this.footwearOrder = Antonioli.filters.footwear_filter_order;
    this.clothingOrder = Antonioli.filters.clothing_filter_order;
  }

  reorderFilters(filterValues, order, key, isSize = false) {

    const splitter = isSize ? '&' : '|'
    const values = [];
    const foundValues = {};

    const sections = order.split(splitter);
      sections.forEach((section, index) => {
        let valueFound = false;
        section.split(',').forEach(orderVal => {
          for (const value of filterValues) {
            if (value[key] === orderVal) {
              foundValues[value[key]] = true;
              values.push(value);
              valueFound = true;
            }
          }
        });
        // valueFound && values.push({ param_name: 'separator' });
      });
    for (const value of filterValues) {
      !foundValues[value[key]] && values.push(value);
    }
    return values;
  }

  createSeparator() {
    const separator = document.createElement('li');
    separator.style.gridColumn = '1/4';
    separator.style.height = '0.1rem';
    separator.style.background = 'black';
    separator.appendChild(document.createElement('p'));
    return separator;
  }

  getOrderStrategy(name) {
    let orderConfig = this.clothingOrder
    
    if (name.includes('size-shoes')) {
      orderConfig = this.footwearOrder
    }
    
    if (name.includes('size-accessories')) {
      orderConfig = this.accessoriesOrder
    }
    if (name.includes('size')) {
      let order;
      const splits = name.split('-');
      const sizeLabel = splits[splits.length - 1].replace('_', '/');
      orderConfig.split('|').forEach(orderGroup => {
        const [label, sizeOrder] = orderGroup.split('=');
        if (label.toLowerCase().startsWith(sizeLabel.toLowerCase()) ) {
          order = sizeOrder;
        }
      });
      return order
    }
  }
}

if (!customElements.get('at-facets-filters')) {
  customElements.define(
    'at-facets-filters',
    class ATFacetsFilters extends HTMLElement {
      constructor() {
        super();
        this.numberOfMacro = false;
        this.type = this.dataset.type ? this.dataset.type : false
        if(this.type) {
          this.renderAllFilters();
        } else {
          this.filterOrderer = new FilterOrderer()
          this.renderFilters();
        }
      }

      renderAllFilters() {
        this.renderMacroCategoryFilters();
        this.renderMicroCategoryFilters();
      }

      renderMicroCategoryFilters() {
        const filters = this.getFilterData();

        if (!filters) return;
        if(this.type == 'micro') {
          // Reset elements
          const children = Array.from(this.childNodes); // Convert NodeList to Array

          children.forEach(node => {
            if (node.nodeType === Node.TEXT_NODE) {
                node.remove(); // Remove text node
            }
          });

            let allValues = this.dataset.values

            let childValues = false, values = allValues;

            if(allValues.includes('#')) {
              allValues = allValues.split('#')
              values = allValues[0]
              childValues = allValues[1]
            }

            const parentElem = this.dataset.parent.toLowerCase()
            const categories = values.split(',');
            categories.forEach(elem => {
              
              const [parent, child] = elem.split('_'); // Destructuring assignment
              const parentCategory = parent.toLowerCase().replace('*','')
              const childCategory = child.toLowerCase().replace('*','')

              if(parentElem === parentCategory && parentCategory != childCategory) {

                const content = this.querySelector('template').content.cloneNode(true);
                const summary = content.querySelector('summary');
                const facetsList = content.querySelector('ul');

                summary.appendChild(this.createSummary(childCategory, childValues))

                const facetItems = document.createDocumentFragment();
                filters.values.forEach(value => {
                  if(childCategory == value.decodedParent && childCategory != value.child) {
                    facetItems.appendChild(this.createFacet(value));
                  }
                });

                facetsList.appendChild(facetItems);

                if(facetsList.getElementsByTagName('li').length > 0)
                  this.appendChild(document.importNode(content, true));
              }
            })

            // [AT-796] nelle plp di terzo livello lasciare le micro gia esplose.
            document.querySelector(`[data-parent='${parentElem}'] .microcategory`).setAttribute('open', '');
        }
      }

      renderMacroCategoryFilters() {
          const filters = this.getFilterData();

          Antonioli.filterToActivate = filters;


          if(this.type == 'macro') {
            this.numberOfMacro = filters.values.length;
            Antonioli.macrocategoryLength = filters.values.length;
          }

          // Exit early if filters are not available or type is not 'macro'
          if (!filters || this.type !== 'macro') {
              return;
          }

          // Select the <ul> element once and clear its content
          const ulElement = this.querySelector('ul');
          ulElement.innerHTML = ''; // Clear existing content

          // Filter and append matching filter values
          const facetItems = document.createDocumentFragment();

          filters.values.forEach(value => {
              const parent = this.dataset.parent;
              if (parent && parent.includes(value.parent)) {
                  const facetElement = this.createFacet(value);
                  facetItems.appendChild(facetElement);
              }
          });

          ulElement.appendChild(facetItems);
      }

      /**
       * Create a facet element based on the provided filter data.
       *
       * @param {object} filter - The filter data to create the facet for.
       * @return {Element} The created facet element.
       */
      createFacet(filter) {
        if (filter.param_name === 'separator') {
          const separator = document.createElement('li');
          separator.className = 'tw-h-[0.1rem] tw-bg-black tw-w-full';

          const label = document.createElement('span');
          label.className = 'tw-invisible';
          label.textContent = 'divider';

          separator.appendChild(label);
          return separator;
        }

        const isDisabled = filter.count == 0 ? 'disabled' : ''
        const isDisabledClass = isDisabled ? 'facet-checkbox--disabled disabled' : ''
        const active = filter.active == 'true' ? 'active' : '';
        const checked = filter.active == 'true' ? 'checked' : '';
        const microToSelectHandle = new StringTransformer(filter.value);

        const item = document.createElement('li');
        item.className = `facets__item tw-flex-col tw-items-start tw-capitalize facets__${filter.param_name}`;
        item.id = `${filter.param_name}-${filter.value}`;

        const label = document.createElement('label');
        label.className = `facets__label tw-group facet-checkbox ${isDisabledClass} ${active}`.trim();
        label.setAttribute('for', `Filter-${filter.param_name}-${filter.value}`);

        const input = document.createElement('input');
        input.name = filter.param_name;
        input.type = 'checkbox';
        input.id = `Filter-${filter.param_name}-${filter.value}`;
        input.setAttribute('micro-select', microToSelectHandle.toHandleize);
        input.value = filter.value;
        input.checked = checked === 'checked';
        input.disabled = isDisabled === 'disabled';

        const text = document.createElement('span');
        text.className = 'facet-checkbox__text group-[.active]:tw-border-b tw-link-menu';
        text.setAttribute('aria-hidden', 'true');

        const value = document.createElement('span');
        value.className = 'value';
        value.setAttribute('aria-hidden', 'true');
        value.textContent = filter.label;

        text.appendChild(value);
        label.append(input, text);
        item.appendChild(label);

        return item;
        
      }

      /**
       * Create a microcategory summary element.
       *
       * @param {string} category - Category label to render.
       * @param {string} categories - Comma-separated category values used for the counter.
       * @return {HTMLDivElement} The summary content element.
       */
      createSummary(category, categories) {
        let counter = categories? categories.split(',').length : '';

        const wrapper = document.createElement('div');
        wrapper.className = 'tw-pointer-events-none';

        const label = document.createElement('span');
        label.className = 'facets__summary-label tw-h3-bol tw-uppercase';
        label.append(document.createTextNode(category.toLowerCase()));

        const selected = document.createElement('span');
        selected.className = 'facets__selected no-js-hidden';

        const count = document.createElement('sup');
        count.className = '-tw-top-[1rem] tw-font-normal tw-text-[0.8rem] -tw-ml-[0.03rem]';
        count.textContent = counter;

        label.append(selected, count);

        const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        icon.setAttribute('class', 'icon icon-caret group-open/details:tw-rotate-180 tw-group/svg');
        icon.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        icon.setAttribute('width', '13.685');
        icon.setAttribute('height', '12.544');
        icon.setAttribute('viewBox', '0 0 13.685 12.544');

        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('id', 'Poligono_26');
        path.setAttribute('class', 'group-open/details:tw-fill-black group-hover/svg:tw-stroke-2');
        path.setAttribute('data-name', 'Poligono 26');
        path.setAttribute('d', 'M6,0l6,11H0Z');
        path.setAttribute('transform', 'translate(12.842 11.5) rotate(180)');
        path.setAttribute('fill', 'none');
        path.setAttribute('stroke', '#000');
        path.setAttribute('stroke-width', '1');

        icon.appendChild(path);
        wrapper.append(label, icon);

        return wrapper;
      }

      renderFilters() {
        const filter = this.getFilterData();
        if (!filter) return;

        const order = this.filterOrderer.getOrderStrategy(filter.param_name);

        const values = order ? this.filterOrderer.reorderFilters(filter.values, order, 'value', filter.param_name?.includes('size')) : filter.values;

        const ulElement = this.querySelector('ul');
        const facetItems = document.createDocumentFragment();

        values.forEach((value, index) => {
          if (value.param_name === 'separator' && index < values.length - 1) {
            facetItems.appendChild(this.createFacet(value));
          } else {
            facetItems.appendChild(this.createFacet(value));
          } 
        });

        ulElement.appendChild(facetItems);
      }

      getFilterData() {
        if (this.filterData) return this.filterData;

        const textContent = this.querySelector('[type="application/json"]')?.textContent;
        if (!textContent) return;
        const filterJson = JSON.parse(textContent)

        // filterJson.values = filterJson.values.filter(value => parseInt(value.count) > 0)
        filterJson.values = filterJson.values.map(value => ({
          ...value,
          decodedParent: this.decodeHtml(value.parent),
        }));
        this.filterData = this.filterData || filterJson;
        return this.filterData;
      }

      /**
       * Decode Liquid-rendered HTML entities without parsing markup during render loops.
       *
       * @param {string} value - The encoded value to decode.
       * @return {string} The decoded text value.
       */
      decodeHtml(value) {
        const decoder = this.htmlDecoder || document.createElement('textarea');
        decoder.innerHTML = value || '';
        this.htmlDecoder = decoder;
        return decoder.value;
      }

    }
  );
}
